import { ApiError, PaginatedResponse } from '@gorila-shared-ui/components';
import { Place, PlaceCore } from '../types/place';
import { deleteRequest, getRequest, postRequest } from './api';
import { placeUrl, placesUrl } from './urls/placeUrls';

export const getPlaces = async (
  clientId: string,
  subClientId: string,
  page: number = 1,
  search: string = ''
): Promise<{ paginatedResponse?: PaginatedResponse<Place>; error?: ApiError }> => {
  const response = await getRequest(placesUrl, { queryParams: { clientId, subClientId, page, search } });
  return {
    paginatedResponse: response?.data,
    error: response?.error,
  };
};

export const deletePlace = async (
  clientId: string,
  subClientId: string,
  placeId: string
): Promise<{ error?: ApiError }> => {
  const response = await deleteRequest(placeUrl(placeId), { queryParams: { clientId, subClientId } });

  return {
    error: response?.error,
  };
};

export const updatePlace = async (
  clientId: string,
  subClientId: string,
  place: PlaceCore
): Promise<{ id?: string; error?: ApiError }> => {
  const response = await postRequest(placeUrl(place._id), {
    body: { ...place, subClientId, clientId },
  });

  return {
    id: response?.data?.id,
    error: response?.error,
  };
};

export const postPlace = async (
  clientId: string,
  subClientId: string,
  place: PlaceCore
): Promise<{ id?: string; error?: ApiError }> => {
  const response = await postRequest(placesUrl, {
    body: { ...place, subClientId, clientId },
  });

  return {
    id: response?.data?.id,
    error: response?.error,
  };
};
